module.exports = __webpack_public_path__ + "common/sidebar-all-categories-9d1312bdc23e5e8987e318202ea34ad0.png";